import { useTranslation } from "react-i18next";
import { TradingStrategySignalAction } from "../../../api/hooks/useSignals";
import { signalActionLabel } from "../../../lib/signal-copy";

/** Buy in the positive tone and exit neutral: an exit is not a loss, and a signal carries no result. */
export function SignalActionBadge({ action }: { action: number }) {
  const { t } = useTranslation("signals");
  const tone =
    action === TradingStrategySignalAction.Buy
      ? "tinted-success text-body"
      : "bg-body-secondary text-body border";

  return (
    <span
      className={`badge rounded-pill fw-semibold ${tone}`}
      style={{ minWidth: "3.5rem" }}
    >
      {signalActionLabel(action, t)}
    </span>
  );
}
